<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="valid-values-tab" style="min-height: 300px">

	<div *ngIf="variableDetails?.scale?.dataType?.name === dataType.NUMERIC">
		<div class="row fw-bold" jhiTranslate="ontology.variable-details.valid-values.numeric.expected.title">
			 Variable Expected Range
		</div>

		<div class="row ps-4 pt-3" *ngIf="variableDetails?.expectedRange?.min == null && variableDetails?.expectedRange?.max == null"
			 jhiTranslate="ontology.variable-details.valid-values.numeric.no-values">
			This numeric variable has no mininum and maximum value constraint.
		</div>

		<div *ngIf="variableDetails?.expectedRange?.min != null && variableDetails?.expectedRange?.max != null">
			<div class="row ps-4 pt-3">
				<div class="mx-auto fw-bold" style="width: 120px;" jhiTranslate="ontology.variable-details.valid-values.min-value">Minimum Value:</div>
				<div class="col ps-4">{{variableDetails?.expectedRange?.min}}</div>
			</div>

			<div class="row ps-4 pt-3">
				<div class="mx-auto fw-bold" style="width: 120px;" jhiTranslate="ontology.variable-details.valid-values.max-value">Maximum Value:</div>
				<div class="col ps-4">{{variableDetails?.expectedRange?.max}}</div>
			</div>
		</div>

		<div class="row fw-bold pt-4" jhiTranslate="ontology.variable-details.valid-values.numeric.scale.title">
			Variable Scale Range
		</div>

		<div class="row ps-4 pt-3">
			<div class="mx-auto fw-bold" style="width: 120px;" jhiTranslate="ontology.variable-details.valid-values.numeric.scale.name">Scale Name:</div>
			<div class="col ps-4">{{variableDetails?.scale?.name}}</div>
		</div>

		<div class="row ps-4 pt-3" *ngIf="variableDetails?.scale?.validValues?.min == null && variableDetails?.scale?.validValues?.max == null"
			 jhiTranslate="ontology.variable-details.valid-values.numeric.no-values">
			This numeric variable has no mininum and maximum value constraint.
		</div>

		<div *ngIf="variableDetails?.scale?.validValues?.min != null && variableDetails?.scale?.validValues?.max != null">
			<div class="row ps-4 pt-3">
				<div class="mx-auto fw-bold" style="width: 120px;" jhiTranslate="ontology.variable-details.valid-values.min-value">Minimum Value:</div>
				<div class="col ps-4">{{variableDetails?.scale?.validValues?.min}}</div>
			</div>

			<div class="row ps-4 pt-3">
				<div class="mx-auto fw-bold" style="width: 120px;" jhiTranslate="ontology.variable-details.valid-values.max-value">Maximum Value:</div>
				<div class="col ps-4">{{variableDetails?.scale?.validValues?.max}}</div>
			</div>
		</div>
	</div>

	<div *ngIf="variableDetails?.scale?.dataType?.name === dataType.CATEGORICAL">
		<div class="row ps-4" *ngIf="!variableDetails?.scale?.validValues?.categories"
			 jhiTranslate="ontology.variable-details.valid-values.categorical.no-values">
			This categorical variable has no pre-defined set of valid values.
		</div>

		<div class="table-responsive" *ngIf="variableDetails?.scale?.validValues?.categories">
			<table class="table table-striped table-bordered table-curved" *ngIf="variableDetails?.scale?.validValues?.categories?.length">
				<thead>
				<tr>
					<th><span jhiTranslate="ontology.variable-details.valid-values.categorical.table.label">Label</span></th>
					<th><span jhiTranslate="ontology.variable-details.valid-values.categorical.table.description">Description</span></th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let category of variableDetails?.scale?.validValues?.categories">
					<td>{{category.name}}</td>
					<td>{{category.description}}</td>
				</tr>
				</tbody>
			</table>
		</div>

	</div>

	<div *ngIf="variableDetails?.scale?.dataType?.name === dataType.CHARACTER">
		<div class="row ps-4" *ngIf="!variableDetails?.scale?.validValues?.categories"
			 jhiTranslate="ontology.variable-details.valid-values.character.no-values">
			Character variables have no pre-defined selection of values
		</div>
	</div>

</div>
